module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/venues-tile-d4f0c9462c9d70cdf9a5cc71de56db39.jpg";